import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center justify-between w-full px-4" }
const _hoisted_3 = { class: "font-medium font-semibold" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "color-blue-grey mr-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Total Resi: ")
const _hoisted_7 = {
  key: 0,
  class: "color-blue-grey"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Total Koli: ")
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1 text-sm" }, "Estimasi Pendapatan", -1)
const _hoisted_11 = { class: "font-bold color-primary" }
const _hoisted_12 = {
  key: 0,
  class: "px-4 py-3 w-full text-center"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "lds-dual-ring" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center" }, "Harap Tunggu", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_17 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_18 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_19 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_20 = { class: "flex gap-2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  class: "rounded-md background-green-lighten-5 py-1 px-3 w-24",
  style: {"border":"1px solid #66BB6A"}
}, [
  /*#__PURE__*/_createVNode("p", { class: "color-green-darken-1 text-sm text-center mx-auto" }, "Berangkat")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "pi pi-print" }, null, -1)
const _hoisted_23 = {
  key: 2,
  class: "px-4 py-3"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center" }, "Belum Ada Keberangkatan", -1)
const _hoisted_25 = {
  key: 1,
  class: "text-center p-4 color-blue-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_DialogDetailResi = _resolveComponent("DialogDetailResi")

  return (_openBlock(), _createBlock("section", null, [
    (_ctx.data.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Accordion, {
            class: "card-accordion og-accordion",
            onTabOpen: _ctx.expandedAccordion
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock(_component_AccordionTab, {
                  key: 'tab-' + index
                }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_2, [
                      _createVNode("div", null, [
                        _createVNode("h6", _hoisted_3, _toDisplayString(item.Agen), 1),
                        _createVNode("div", _hoisted_4, [
                          _createVNode("p", _hoisted_5, [
                            _hoisted_6,
                            _createVNode("b", null, _toDisplayString(item.TotalResi), 1)
                          ]),
                          (_ctx.checkPermission(_ctx.PermissionEnum.ShowDetLoadMan))
                            ? (_openBlock(), _createBlock("p", _hoisted_7, [
                                _hoisted_8,
                                _createVNode("b", null, _toDisplayString(item.TotalKoli), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode("h5", _hoisted_11, "Rp " + _toDisplayString(new Number(item.Pendapatan).toLocaleString('id-ID')), 1)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (item.loading)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _hoisted_14
                        ]))
                      : (item.resi.length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_15, [
                            _createVNode(_component_DataTable, {
                              value: item.resi,
                              class: "table-og body-td-x-0",
                              responsiveLayout: "scroll"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, { header: "Nomor Resi" }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode("p", _hoisted_16, _toDisplayString(slotProps.data.Resi), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, { header: "Jml Koli" }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode("p", _hoisted_17, _toDisplayString(slotProps.data.TransPengirimanDetails.length), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, { header: "Nopol Bis" }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode("p", _hoisted_18, _toDisplayString(slotProps.data.Manifest.Nopol), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, { header: "Nama Pamugara" }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode("p", _hoisted_19, _toDisplayString(slotProps.data.Manifest.NamaPramugara), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, { header: "Status" }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode("div", _hoisted_20, [
                                      _hoisted_21,
                                      (_ctx.canPrint)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 0,
                                            class: "font-semibold btn-primary",
                                            onClick: ($event: any) => (_ctx.printResi(slotProps.data))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_22
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_23, [
                            _hoisted_24
                          ]))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["onTabOpen"])
        ]))
      : (_openBlock(), _createBlock("p", _hoisted_25, "Tidak Ada Manifest")),
    (_ctx.showDialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResi, {
          key: 2,
          isRefund: false,
          idTrans: _ctx.idManifest,
          isShowDialog: _ctx.showDialogDetail,
          onReloadData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAllData())),
          onHideDialog: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialogDetail = false))
        }, null, 8, ["idTrans", "isShowDialog"]))
      : _createCommentVNode("", true)
  ]))
}